import { render, staticRenderFns } from "./UnprotectedViewFooter.vue?vue&type=template&id=36554481&scoped=true"
import script from "./UnprotectedViewFooter.vue?vue&type=script&lang=js"
export * from "./UnprotectedViewFooter.vue?vue&type=script&lang=js"
import style0 from "./UnprotectedViewFooter.vue?vue&type=style&index=0&id=36554481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36554481",
  null
  
)

export default component.exports